export const arrowLeft = require('./arrow-left.svg');
export const arrowRight = require('./arrow-right.svg');
export const chevronDown = require('./chevron-down.svg');
export const information = require('./information.svg');
// Product iconen
export const kastenArchiefrekken = require('./kasten-archiefrekken.svg');
export const kastenBezemschoonmaakkasten = require('./kasten-bezemschoonmaakkasten.svg');
export const kastenFolderrekken = require('./kasten-folderrekken.svg');
export const kastenGarderobekasten = require('./kasten-garderobekasten.svg');
export const kastenLockers = require('./kasten-lockers.svg');
export const kastenPostvakkenkasten = require('./kasten-postvakkenkasten.svg');
export const kastenRoldeurkasten = require('./kasten-roldeurkasten.svg');
export const kastenSchoenenkasten = require('./kasten-schoenenkasten.svg');
export const kastenTijdschriftenkasten = require('./kasten-tijdschriftenkasten.svg');
export const kastenVakkenkasten = require('./kasten-vakkenkasten.svg');
export const kastenWaskasten = require('./kasten-waskasten.svg');
export const sluitsystemenCijfersloten = require('./sluitsystemen-cijfersloten.svg');
export const sluitsystemenCylindersloten = require('./sluitsystemen-cylindersloten.svg');
export const sluitsystemenHangsloten = require('./sluitsystemen-hangsloten.svg');
export const sluitsystemenPandsloten = require('./sluitsystemen-pandsloten.svg');
export const sluitsystemenPassensloten = require('./sluitsystemen-passensloten.svg');
export const sluitsystemenPincodesloten = require('./sluitsystemen-pincodesloten.svg');
export const overigeOverige = require('./overige-overige.svg');
